import React, { useEffect } from 'react';
import './AlertModal.scss';

const AlertModal = ({ 
  isOpen, 
  type = 'success', // 'success' | 'error' | 'info'
  title,
  message, 
  onClose,
  autoClose = true, // 자동 닫기 (성공 메시지에 유용)
  autoCloseDelay = 2000, // 자동 닫기 지연 시간 (ms)
  confirmText = '확인'
}) => {
  // 자동 닫기 (early return 전에 호출해야 함)
  useEffect(() => {
    if (autoClose && isOpen && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose]);

  if (!isOpen) return null;
  const fallbackTitle = type === 'error' ? '오류' : '알림';

  return (
    <div className="alert-modal-overlay">
      <div className={`alert-modal-content alert-modal-${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="alert-modal-header">
          <h2>{title || fallbackTitle}</h2>
        </div>
        <div className="alert-modal-body">
          <p className="alert-modal-message">{message}</p>
        </div>
        <button 
          className="alert-modal-close-btn"
          onClick={onClose}
        >
          {confirmText}
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
